/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Overwrite_ConfirmInputs */



/**
* | output |
* | --- |
* | "Overwrite" |
*
* @param {Explorer_Display_Overwrite_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_overwrite_confirm = /** @type {((inputs?: Explorer_Display_Overwrite_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Overwrite_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ecraser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschreiben")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sovrascrivi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезаписать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exagerar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("覆盖")
	if (locale === "ja") return /** @type {LocalizedString} */ ("上書き")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओवरराइट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sobrescrever")
	return /** @type {LocalizedString} */ ("Overwrite")
});